import { ComponentType } from '@angular/cdk/portal';
import { Component, inject, Type } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { MatDialog } from '@angular/material/dialog';
import { FieldType, FieldTypeConfig, FormlyFieldConfig, FormlyFieldProps } from '@ngx-formly/core';
import { DialogComponent } from './dialogs/default.dialog.component';
import { ElasticMooseCollarInfoDialogComponent } from './dialogs/elastic-moose-collar-info.dialog.component';
import { OneHousingCollarElasticBeltsInfoDialogComponent } from './dialogs/one-housing-collar-elastic-belts-info.dialog.component';
import { TwoHousingCollarElasticBeltsInfoDialogComponent } from './dialogs/two-housing-collar-elastic-belts-info.dialog.component';

const INFO_DIALOGS: Record<string, ComponentType<unknown>> = {
  'oof/two-housing-collar-elastic-belts': TwoHousingCollarElasticBeltsInfoDialogComponent,
  'oof/one-housing-collar-elastic-belts': OneHousingCollarElasticBeltsInfoDialogComponent,
  'oof/moose-collar-elastic-belts': ElasticMooseCollarInfoDialogComponent,
  default: DialogComponent,
} as const;

export interface InfoWithDialogProps extends FormlyFieldProps {
  modalTitle?: string;
  modalContent?: string;
  modalName?: keyof typeof INFO_DIALOGS;
  buttonLabel?: string;
}

export interface FormlyInfoWithDialogFieldConfig extends FormlyFieldConfig<InfoWithDialogProps> {
  type: 'dialog-info' | Type<InfoWithDialogComponent>;
}

@Component({
  selector: 'vectronic-formly-info-with-dialog',
  imports: [MatButton],
  template: `
    <div class="alert alert-info">
      <div [innerHTML]="field.props?.label"></div>
      @if (field.props?.modalContent || field.props?.modalName) {
        <button mat-button color="primary" (click)="openModal()">
          {{ field.props?.buttonLabel || 'Learn More' }}
        </button>
      }
    </div>
  `,
  styles: [``],
})
export class InfoWithDialogComponent extends FieldType<FieldTypeConfig<InfoWithDialogProps>> {
  dialog = inject(MatDialog);

  openModal() {
    this.dialog.open(INFO_DIALOGS[this.field.props?.modalName ?? 'default'], {
      data: {
        title: this.field.props?.modalTitle || 'More Information',
        content: this.field.props?.modalContent,
      },
      width: '1400px',
      maxWidth: '100vw',
      maxHeight: '100dvh',
    });
  }
}
